import { z } from 'zod';
/** Machine keys for FR-001 dimensions (aligned to OpenAPI `ReadinessDimensionKey`). */
export const readinessDimensionKeySchema = z.enum([
    'approvals',
    'freshness',
    'coverage',
    'done_conditions',
    'governance',
]);
/** Minimal triage DTO — same shape as `WorkItemReadinessSnippet` (DC-373). */
export const workItemReadinessSnippetSchema = z.object({
    aggregateStatus: z.enum(['ready_for_implementation', 'not_ready', 'blocked']),
    headline: z.string(),
    blockingDimension: readinessDimensionKeySchema.nullable().optional(),
    evaluatedAt: z.string().datetime().optional(),
    inputPointerHash: z.string().optional(),
});
//# sourceMappingURL=work-item-readiness-snippet.schema.js.map